import { Inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, Jurisdiction, JurisdictionSelector, STARTUP_CONTEXT_TOKEN, StartupContext } from "@obg/ngx.core";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { iif, Observable, of } from "rxjs";
import { map, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { GeoFencingAction } from "./geofencing.action";
import { GEOFENCING_ERROR } from "./geofencing.const";

@Injectable({ providedIn: "root" })
export class GeofencingGuard implements CanActivate {
	constructor(
		private store: Store<CommonState>,
		@Inject(STARTUP_CONTEXT_TOKEN) private startupContext: StartupContext
	) {}

	canActivate(): Observable<boolean> {
		const { countryCode } = this.startupContext.appContext;

		return this.store.select(JurisdictionSelector.get).pipe(
			switchMap((jurisdiction: Jurisdiction) => {
				return iif(
					() => jurisdiction === Jurisdiction.Mga && countryCode === "BR",
					of(false).pipe(
						withLatestFrom(this.store.select(RouteSelector.getCurrent)),
						map(([decision, currentRoute]) => {
							if (!currentRoute) {
								this.store.dispatch(
									GeoFencingAction.validateLocationFailure(GEOFENCING_ERROR.InvalidCountryAccess)
								);
								this.store.dispatch(
									RouteAction.navigate(CORE_ROUTE.home, {}, { onSameUrlNavigation: "reload" })
								);
							} else {
								this.store.dispatch(GeoFencingAction.showErrorAlert(jurisdiction));
							}

							return decision;
						})
					),
					of(true)
				);
			})
		);
	}
}
